import {
  QueryBuilderQuery,
  BooleanOperator,
  Operator,
  SearchContext,
} from '@ardoq/api-types';
import { NonEmptyArray } from '@ardoq/common-helpers';

export const getTypeQuery = (typeName: string): QueryBuilderQuery =>
  getTypesQuery([typeName]);

export const getTypesQuery = (
  typeNames: NonEmptyArray<string>
): QueryBuilderQuery => ({
  condition: BooleanOperator.AND,
  rules: [
    {
      field: 'type',
      id: 'type',
      input: 'select',
      operator: Operator.EQUAL,
      type: 'string',
      value: SearchContext.COMPONENT,
    },
    {
      condition: BooleanOperator.AND,
      rules: [
        {
          id: 'typeName',
          field: 'typeName',
          input: 'text',
          type: 'string',
          operator: typeNames.length > 1 ? Operator.IN : Operator.EQUAL,
          value: typeNames.length > 1 ? typeNames : typeNames[0],
        },
      ],
    },
  ],
});
